import { Card, CardBody, GeneralInfoItem } from '@/common'
import useI18n from '@/shared/hooks/useI18n'
import { InstallationWithResources } from '@/features/installations/api/InstallationModel'
import { formatAddressLine } from '@/common'

export default function InstallationCard({
  installation: {
    street,
    streetNumber,
    postCode,
    city,
    country,
    basisForReportingPeriod,
    startMonth,
    goodsFamily,
    monthInterval
  }
}: {
  installation: InstallationWithResources
}) {
  const { t } = useI18n()

  const countryName = t(`countriesByIsoAlpha2:${country}`)
  const formattedAddress = formatAddressLine(street, streetNumber, postCode, city, countryName)
  const goodsFamilyName = t(`installations:fields.goodsFamily.options.${goodsFamily}`)

  return (
    <div className="grid grid-cols-2 gap-4">
      <Card>
        <CardBody>
          <GeneralInfoItem
            label={t('dashboard:details.items.goodsFamily')}
            value={goodsFamilyName}
          />
        </CardBody>
      </Card>
      <Card>
        <CardBody>
          <GeneralInfoItem label={t('dashboard:details.items.address')} value={formattedAddress} />
        </CardBody>
      </Card>

      <Card className="col-span-2">
        <CardBody>
          <GeneralInfoItem
            label={t('dashboard:details.items.basisForReportingPeriod')}
            value={
              <>
                {t(
                  `installations:fields.basisForReportingPeriod.options.${basisForReportingPeriod}.label`
                )}{' '}
                \{' '}
                {t('installations:list.item.monthInterval', {
                  monthInterval,
                  month: t(`common:months:${startMonth}`)
                })}
              </>
            }
          />
        </CardBody>
      </Card>
    </div>
  )
}
